import styles from './index.module.sass'

export function Wave(props) {
  return <div className={styles.wave} {...props} />
}
